<template>
  <div>
    <!-- Overview Summary -->
    <div v-if="overviewData" class="overview-section mb-4">
      <div class="overview-grid">
        <div class="overview-item">
          <span class="overview-label">Total Ports:</span>
          <span class="overview-value">{{ overviewData.Total || 0 }}</span>
        </div>
        <div class="overview-item">
          <span class="overview-label">Registered:</span>
          <span class="overview-value">{{ overviewData.Register || 0 }}</span>
        </div>
        <div class="overview-item">
          <span class="overview-label">Active:</span>
          <span class="overview-value text-success">{{ overviewData.Active || 0 }}</span>
        </div>
        <div class="overview-item">
          <span class="overview-label">Online:</span>
          <span class="overview-value text-success">{{ overviewData.Online || 0 }}</span>
        </div>
        <div class="overview-item">
          <span class="overview-label">ONU Alarms:</span>
          <span class="overview-value" :class="overviewData.OnuAlarm > 0 ? 'text-danger' : 'text-muted'">
            {{ overviewData.OnuAlarm || 0 }}
          </span>
        </div>
      </div>
    </div>

    <!-- Port Details Table -->
    <table class="table align-items-center mb-0">
      <thead>
        <tr>
          <th class="text-sm">Port</th>
          <th class="text-sm">Status</th>
          <th class="text-sm">Tx Power (dBm)</th>
          <th class="text-sm">Rx Power (dBm)</th>
          <th class="text-sm">Temperature (°C)</th>
          <th class="text-sm">Voltage (V)</th>
          <th class="text-sm">Bias (mA)</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="loading">
          <tr>
            <td colspan="7">
              <Skalaton />
            </td>
          </tr>
        </template>
        <template v-else-if="!portData || portData.length === 0">
          <tr>
            <td colspan="7" class="text-center text-muted p-4">
              No port data available
            </td>
          </tr>
        </template>
        <template v-else>
          <tr
            v-for="port in portData"
            :key="port.Index"
          >
            <td class="text-sm">
              <span class="port-name">{{ port.port }}</span>
            </td>
            <td class="text-sm">
              <span
                class="badge"
                :class="getStatusBadgeClass(port.Status)"
                style="text-transform: uppercase; color: rgb(255 249 249) !important;"
              >
                {{ getStatusText(port.Status) }}
              </span>
            </td>
            <td class="text-sm">{{ formatPower(port.TxPower) }}</td>
            <td class="text-sm" :class="getRxPowerClass(port.RxPower)">
              {{ formatPower(port.RxPower) }}
            </td>
            <td class="text-sm">{{ formatTemperature(port.Temp) }}</td>
            <td class="text-sm">{{ formatVoltage(port.Voltage) }}</td>
            <td class="text-sm">{{ formatBias(port.Bias) }}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'GponClodePortSummary',
  components: {
    Skalaton
  },
  props: {
    portData: {
      type: Array,
      default: () => []
    },
    overviewData: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getStatusText(status) {
      return status ? 'Online' : 'Offline';
    },
    
    getStatusBadgeClass(status) {
      return status ? 'bg-success' : 'bg-danger';
    },
    
    formatPower(power) {
      if (power === null || power === undefined || power === 0) return 'N/A';
      return `${power.toFixed(2)}`;
    },
    
    getRxPowerClass(rxPower) {
      if (rxPower === null || rxPower === undefined || rxPower === 0) return '';
      if (rxPower > -20) return 'text-danger';
      if (rxPower > -25) return 'text-warning';
      return 'text-success';
    },
    
    formatTemperature(temp) {
      if (temp === null || temp === undefined || temp === 0) return 'N/A';
      return `${temp.toFixed(2)}`;
    },
    
    formatVoltage(voltage) {
      if (voltage === null || voltage === undefined || voltage === 0) return 'N/A';
      return `${voltage.toFixed(2)}`;
    },
    
    formatBias(bias) {
      if (bias === null || bias === undefined || bias === 0) return 'N/A';
      return `${bias.toFixed(2)}`;
    }
  }
}
</script>

<style scoped>
.overview-section {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}

.overview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.overview-label {
  font-size: 0.75rem;
  color: #aaa;
  margin-bottom: 4px;
  text-align: center;
}

.overview-value {
  font-size: 1.25rem;
  font-weight: 600;
  color: #fff;
}

.port-name {
  font-weight: 500;
  color: #82D616;
}

.text-success {
  color: #82D616 !important;
}

.text-danger {
  color: #e74c3c !important;
}

.text-warning {
  color: #f39c12 !important;
}

.text-muted {
  color: #999 !important;
}
</style>

